import { CheckCircle2, Circle, Truck, ExternalLink, Clock } from "lucide-react";

const fmt = (iso) => (iso ? new Date(iso).toLocaleDateString(undefined, { month: "short", day: "numeric" }) : "");
const range = (e) => (e ? `${fmt(e.from)} – ${fmt(e.to)}` : "");

export const OrderTimeline = ({ order }) => {
  const t = order.tracking;
  if (!t) return null;
  return (
    <div className="rounded-xl border border-slate-800 bg-[#0f1219] p-4 space-y-3" data-testid={`order-timeline-${order.order_id}`}>
      <div className="flex flex-wrap items-center gap-3">
        <p className="font-mono text-[10px] uppercase tracking-widest text-slate-500 flex-1">Tracking</p>
        {t.estimated_delivery && <p className="text-xs text-cyan-300 flex items-center gap-1" data-testid={`order-eta-${order.order_id}`}><Clock className="w-3.5 h-3.5" />Est. delivery {range(t.estimated_delivery)}</p>}
        {order.status === "delivered" && <p className="text-xs text-emerald-300" data-testid={`order-delivered-${order.order_id}`}>Delivered{order.delivered_at ? ` ${fmt(order.delivered_at)}` : ""}</p>}
      </div>
      <ol className="relative space-y-3 pl-5 border-l border-slate-800 ml-1.5">
        {t.steps.map((s) => (
          <li key={s.key} className="relative" data-testid={`order-step-${order.order_id}-${s.key}`}>
            <span className={`absolute -left-[26px] top-0.5 rounded-full bg-[#0f1219] ${s.done ? "text-emerald-300" : "text-slate-700"}`}>{s.current ? <Truck className="w-4 h-4 text-cyan-300 animate-pulse" /> : s.done ? <CheckCircle2 className="w-4 h-4" /> : <Circle className="w-4 h-4" />}</span>
            <p className={`text-sm leading-tight ${s.done ? "text-slate-200" : "text-slate-500"}`}>{s.label}</p>
            {s.at && <p className="text-[11px] font-mono text-slate-500">{new Date(s.at).toLocaleString()}</p>}
            {s.key === "transit" && s.current && <p className="text-[11px] text-slate-400">{t.supplier_shipped ? "Shipping from supplier warehouse · 7–14 days typical" : "Shipped from Miami · 3–5 days typical"}</p>}
          </li>
        ))}
      </ol>
      {order.tracking_number && (
        <div className="flex flex-wrap items-center gap-2 pt-1 text-xs">
          <span className="font-mono text-slate-300" data-testid={`order-tracking-number-${order.order_id}`}>{order.carrier} {order.tracking_number}</span>
          {t.tracking_url && <a href={t.tracking_url} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1 px-3 h-7 rounded-full border border-cyan-400/40 text-cyan-300 hover:bg-cyan-400/10" data-testid={`order-track-link-${order.order_id}`}>Track on {order.carrier}<ExternalLink className="w-3 h-3" /></a>}
        </div>
      )}
    </div>
  );
};
